// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2Evgv","boxTitle":"Qualiphy_boxTitle___deX0","box":"Qualiphy_box__3La5c","toggleWrap":"Qualiphy_toggleWrap__3Y_UZ"};